import React, { useContext, useState, useEffect } from 'react'

import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'

import TracksTable from '../TracksTable'

import styles from './TracksTable.module.css'

export default function UsersPage() {
    return (
        <>
            <Typography
                variant="h4"
                component="h1"
                className={styles.page__title}
            >
                Страница треков
            </Typography>
            <Divider />
            <TracksTable />
        </>
    )
}
